module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_duo_cuad_15.87e060d6.png";